<template>
  <div class="d-flex pa-2">
    <div
      v-for="c in children"
      :key="c.childId"
      class="icon mr-2"
    >
      <img
        :src="c.imageUrl? c.imageUrl : 'https://via.placeholder.com/240x180?text=Sample+Image+1'"
      >
    </div>
    <v-btn
      @click="$router.push({ path: '/child/add', name: 'ChildAdd' })"
      color="primary"
      class="white--text"
      depressed
      icon
      outlined
      raised
      height="60"
      width="60"
    >
      <v-icon dark>
        mdi-plus
      </v-icon>
    </v-btn>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';

import { familyModule } from '@/store/entityModules/family';

// model
import {
  SearchChildrenResponse,
  ParentResponse,
  ChildResponse,
  FamilyResponse,
} from '@API/src/component/home/family/types';

export default defineComponent({

  computed: {
    children(): ChildResponse[] {
      if (familyModule.family) {
        return familyModule.family.children;
      }
      return [];
    },
  },

});
</script>
<style lang="scss" scoped>
.icon {
  height: 60px;
  width: 60px;

  img {
    height: 100%;
    width: 100%;
    border-radius: 100%;
  }
}
</style>
